<template>
  <div class="mt-2">
    <div>
      <v-toolbar class="elevation-1 white--text" color="primary" height="50px">
        <v-toolbar-title>
          <v-icon class="white--text">fa-building</v-icon>
          Availability
        </v-toolbar-title>
        <v-divider class="mx-2" inset vertical />
        <v-spacer />
        <EditPersonAvailabilityDialog />
        <AddPersonAvailabilityDialog
          :person-id="personId"
          v-if="!isContractor"
        />
      </v-toolbar>
      <v-data-table
        :headers="availabilityHeaders"
        :items="personAvailabilityList"
        :sort-by.sync="sortBy"
        class="elevation-1"
        v-if="person !== undefined"
      >
        <template slot="item" slot-scope="props">
          <tr
            :class="{
              'current-fiscal-year': currentFiscalYear == props.item.year,
            }"
          >
            <td class="text-xs-left">{{ props.item.year }}</td>
            <td>{{ props.item.workingDays }}</td>
            <td>{{ props.item.holidayEntitlement }}</td>
            <td>{{ props.item.carriedOver }}</td>
            <td>{{ props.item.specialAllowance }}</td>
            <td>{{ props.item.holidayDaysTaken }}</td>
            <td>{{ props.item.bankHolidayDays }}</td>
            <td>{{ props.item.bankHolidayDaysTaken }}</td>
            <td>{{ props.item.toilDaysAvailable }}</td>
            <td>{{ props.item.toilDaysTaken }}</td>
            <td>{{ props.item.sickDaysTaken }}</td>
            <td>{{ props.item.specialDaysTaken }}</td>
            <td>{{ props.item.totalAvailability }}</td>
            <td class="text-xs-center text-center">
              <v-tooltip bottom v-if="props.item.comments">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="primary" dark v-bind="attrs" v-on="on" style="font-size: 15px;">
                    fa-info
                  </v-icon>
                </template>
                <span>{{ props.item.comments }}</span>
              </v-tooltip>
            </td>
            <td class="justify-center layout px-0" v-if="!isContractor">
              <v-icon
                @click="editItem(props.item)"
                class="mr-2"
                small
                style="display: inline-flex"
              >
                edit
              </v-icon>
              <!-- <v-icon
                @click="deleteItem(props.item)"
                small
                style="display: inline-flex"
              >
                delete
              </v-icon> -->
            </td>
            <td v-else />
          </tr>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { RESET_DEFAULT_AVAILABILITY_TO_EDIT } from "@/store/person_availability/mutations";
import {
  LOAD_PERSON_AVAILABILITY_TO_EDIT,
  TOGGLE_EDIT_PERSON_AVAILABILITY_DIALOG,
} from "@/store/person_availability/mutations.js";
import {
  DELETE_PERSON_AVAILABILITY,
  FETCH_PERSON_AVAILABILITY_LIST,
} from "@/store/person_availability/actions.js";
import EditTableFunctions from "../editTableFunctions";
import AddPersonAvailabilityDialog from "./AddPersonAvailabilityDialog";
import EditPersonAvailabilityDialog from "./EditPersonAvailabilityDialog";

export default {
  name: "PersonHolidayTable",
  components: { AddPersonAvailabilityDialog, EditPersonAvailabilityDialog },
  mixins: [EditTableFunctions],
  props: {
    personId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      idName: "personAvailabilityId",
      dialog: false,
      availabilityHeaders: [
        { text: "Year", align: "left", value: "year" },
        { text: "Working Days", value: "workingDays" },
        { text: "Holiday", value: "holidayEntitlement" },
        { text: "Carried", value: "carriedOver" },
        { text: "Special Allowance", value: "specialAllowance" },
        { text: "Holiday Taken", value: "holidayDaysTaken" },
        { text: "BH", value: "bankHolidayDays" },
        { text: "BH Taken", value: "bankHolidayDaysTaken" },
        { text: "TOIL", value: "toilDaysAvailable" },
        { text: "TOIL Taken", value: "toilDaysTaken" },
        { text: "Sick Taken", value: "sickDaysTaken" },
        { text: "Special Taken", value: "specialDaysTaken" },
        { text: "Remaining Availability", value: "totalAvailability" },
        { text: "Comments", value: "comments" },
        { text: "Actions", value: "name", sortable: false },
      ],
      sortBy: "year",
      rowsPerPageItems: [
        10,
        20,
        50,
        { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 },
      ],
      pagination: {
        rowsPerPage: 10,
      },
      editedId: -1,
      fiscalYearList: [2018, 2019, 2020],
    };
  },

  computed: {
    editFiscalYear: {
      get() {
        return this.$store.state.person_availability.editPersonAvailability
          .fiscalYear;
      },
      set(value) {
        this.updateValue("fiscalYear", value);
      },
    },
    // editHolidayPeriod: {
    //   get() {
    //     return this.$store.state.person_availability.editPersonAvailability
    //       .holidayPeriod;
    //   },
    //   set(value) {
    //     this.updateValue("holidayPeriod", value);
    //   },
    // },
    editCarriedOver: {
      get() {
        return this.$store.state.person_availability.editPersonAvailability
          .carriedOver;
      },
      set(value) {
        this.updateValue("carriedOver", value);
      },
    },
    editYearlyEntitlement: {
      get() {
        return this.$store.state.person_availability.editPersonAvailability
          .holidayEntitlement;
      },
      set(value) {
        this.updateValue("holidayEntitlement", value);
      },
    },
    editSpecialAllowance: {
      get() {
        return this.$store.state.person_availability.editPersonAvailability
          .specialAllowance;
      },
      set(value) {
        this.updateValue("specialAllowance", value);
      },
    },
    editBankHoliday: {
      get() {
        return this.$store.state.person_availability.editPersonAvailability
          .bankHolidayDays;
      },
      set(value) {
        this.updateValue("bankHolidayDays", value);
      },
    },
    editComments: {
      get() {
        return this.$store.state.person_availability.editPersonAvailability
          .comments;
      },
      set(value) {
        this.updateValue("comments", value);
      },
    },
    ...mapGetters([
      "person",
      "personAvailabilityList",
      "employmentTypeList",
      "currentFiscalYear",
      "isContractor",
    ]),
  },

  mounted() {
    if (this.personId) {
      // this.fetchAllTableItems();
    }
  },

  methods: {
    ...mapActions({
      fetchTableList: FETCH_PERSON_AVAILABILITY_LIST,
      deleteTableItem: DELETE_PERSON_AVAILABILITY,
    }),

    ...mapMutations({
      toggleEditDialog: TOGGLE_EDIT_PERSON_AVAILABILITY_DIALOG,
      loadTableItemToEdit: LOAD_PERSON_AVAILABILITY_TO_EDIT,
      resetEditItemToDefault: RESET_DEFAULT_AVAILABILITY_TO_EDIT,
    }),
  },
};
</script>

<style scoped>
.current-fiscal-year {
  background-color: rgb(238, 238, 238);
}
</style>
